import { Environment, mockServerPort } from '@backoffice-frontend/environment'

export const MANUALLY_SELECTED_ORGANIZATION = 'manually-selected-organization'
export const DEFAULT_ORGANIZATION = 'moia-dev'

export const CognitoIdentityProviderStages: Record<Environment, string> = {
  [Environment.test]: `http://localhost:${mockServerPort}/api/cognito-identity-provider`,
  [Environment.local]: `http://localhost:${mockServerPort}/api/cognito-identity-provider`,
  [Environment.development]:
    'https://cognito-identity-provider.backoffice.dev.moia-group.io',
  [Environment.integration]:
    'https://cognito-identity-provider.backoffice.int.moia-group.io',
  [Environment.production]:
    'https://cognito-identity-provider.backoffice.prd.moia-group.io',
}
